<template>
	<em><strong>{{name}}-{{version}}</strong></em>
</template>

<script>
export default {
  props: ["name", "version"]
}

</script>